import React from 'react';
import '../../styles/Modal.css'; // Создайте стили для модального окна

const Modal = ({ onClose, onViewOrder, onClearCart }) => (
    <>
    <div id="other-store__overlay" onClick={onClose}></div>
        <div className="modal-other-store">
            <p>Неможливо додати товар з цього магазину. Спочатку завершіть замовлення в іншому магазині</p>
            <button
                onClick={onViewOrder}
                className="primary_button"
                id="modal_view_order"
            >Подивитися кошик
            </button>
            <button
                onClick={onClearCart}
                className="primary_button"
                id="modal_close"
            >Очистити кошик
            </button>
    </div>
    </>
);

export default Modal;
